export type TextSegment =
  | { type: "text"; value: string }
  | { type: "url"; href: string }

const URL_IN_TEXT_REGEX = /\bhttps?:\/\/[^\s<]+[^\s<.,;:!?'")\]}>]/gi

export function splitTextByUrls(text: string): TextSegment[] {
  if (!text) return []

  const segments: TextSegment[] = []
  let lastIndex = 0
  const regex = new RegExp(URL_IN_TEXT_REGEX.source, URL_IN_TEXT_REGEX.flags)

  for (const match of text.matchAll(regex)) {
    const url = match[0]
    const index = match.index ?? 0

    if (index > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, index) })
    }

    segments.push({ type: "url", href: url })
    lastIndex = index + url.length
  }

  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) })
  }

  return segments.length > 0 ? segments : [{ type: "text", value: text }]
}

export function extractFirstWord(text: string): {
  firstWord: string
  restOfText: string
} {
  const firstSpaceIndex = text.indexOf(" ")
  const firstDashIndex = text.indexOf("-")

  let firstWordEndIndex: number

  if (firstSpaceIndex === -1 && firstDashIndex === -1) {
    firstWordEndIndex = text.length
  } else if (firstSpaceIndex === -1) {
    firstWordEndIndex = firstDashIndex
  } else if (firstDashIndex === -1) {
    firstWordEndIndex = firstSpaceIndex
  } else {
    firstWordEndIndex = Math.min(firstSpaceIndex, firstDashIndex)
  }

  const firstWord = text.substring(0, firstWordEndIndex)
  const restOfText =
    firstWordEndIndex < text.length ? text.substring(firstWordEndIndex) : ""

  return { firstWord, restOfText }
}
